import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {injectIntl, intlShape} from 'react-intl';
import * as FormatUtils from 'utils/formatUtils';
import * as payNowConstants from './constants';
import styles from './payNowConsent.scss';

export const payNowAmountOptionToConsent = {
  [payNowConstants.PAY_NOW_AMOUNT_OPTION_PAST_DUE] : 'payNow.consent.option.pastDue',
  [payNowConstants.PAY_NOW_AMOUNT_OPTION_PARTIAL] : 'payNow.consent.option.partial',
  [payNowConstants.PAY_NOW_AMOUNT_OPTION_NEXT] : 'payNow.consent.option.next',
  [payNowConstants.PAY_NOW_AMOUNT_OPTION_ENTIRE] : 'payNow.consent.option.entire',
};

@injectIntl
@CSSModules(styles, {allowMultiple: true})
class PayNowConsent extends React.Component {

  static propTypes = {
    intl: intlShape,
    cardNumber: PropTypes.string.isRequired,
    amount:  PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    externalId: PropTypes.string.isRequired,
    dueDate: PropTypes.number.isRequired,
    amountOption: PropTypes.string.isRequired,
    isLate: PropTypes.bool,
    isDefaultPayment: PropTypes.bool
  };

  render() {
    const {amountOption, intl:{formatMessage}} = this.props;

    const concentMessageValues = {
      ...this.props,
      amountOptionText: formatMessage({id: payNowAmountOptionToConsent[amountOption]}),
      amount : FormatUtils.addPriceSymbol(this.props.amount),
      dueDate: FormatUtils.transformDate(this.props.dueDate, 'YYYY-MM-DD')
    };

    let messageId = '';
    if (this.props.isLate) {
        messageId = this.props.isDefaultPayment ?  "makeAPaymentPurchaseReviewDisclaimer.LateAutoPay" : "makeAPaymentPurchaseReviewDisclaimer.Late";
    } else {
        messageId = this.props.isDefaultPayment ? "makeAPaymentPurchaseReviewDisclaimer.AutoPay" : "makeAPaymentPurchaseReviewDisclaimer";
    }

    return (
      <div styleName="payNowConsent" data-at="PayNowConsentTxt" >
        {formatMessage({id: messageId}, concentMessageValues)}
      </div>
    );
  }
}


export default PayNowConsent;



// WEBPACK FOOTER //
// ./src/pay-now/PayNowConsent.js